import App from "@/App";
import { SENTRY_ENABLED } from "@/lib/constants";
import * as Sentry from "@sentry/react";
import { NuqsAdapter } from "nuqs/adapters/react";
import React from "react";
import ReactDOM from "react-dom/client";
import "./app.css";
import "./main.css";
import "./style/highcharts.css";

import Highcharts from "highcharts";
Highcharts.setOptions({
  lang: {
    thousandsSep: ",",
  },
});

if (SENTRY_ENABLED) {
  Sentry.init({
    dsn: "https://809ec5f21b09fa17b27e59f1952b20ac@o4508926461280256.ingest.us.sentry.io/4508979874693120",
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
      }),
    ],
    // Performance Monitoring
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: [
      "localhost",
      /^https:\/\/app\.raidohub\.com\/api/,
    ],
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  });
}

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <NuqsAdapter>
      <App />
    </NuqsAdapter>
  </React.StrictMode>
);
